import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../Style/style.scss';
import imagebg from '../Images/energy.jpg';

import validate from '../components/Form/validateInfo';
import useForm from '../components/Form/useForm';
import useBox from '../components/Form/useBox';
import useTable from '../components/Footers/useTable';

import ColumbusContent from '../components/Content/ColumbusContent/ColumbusContent';
import Footer from '../components/Footers/Footer';
import StandardFooter from '../components/Footers/StandardFooter/';

import Form from '../components/Form/Form';
import Common from '../components/Form/Common';
import Button from '../components/Form/Button';
import Image from '../components/Form/Image';
import AvatarBox from '../components/Form/Image/AvatarBox';
import PhotosBox from '../components/Form/Image/PhotosBox';
import UploadBox from '../components/Form/Image/UploadBox';
import Overlay from '../components/Overlay';
import Sidebar from '../components/Sidebar';

const ColumbusPage = (props) => {
  const {mailBox, setMailBox} = useTable();

  const {
    overlayToggle,
    avatarBoxToggle,
    photosBoxToggle,
    overlayActive,
    avatarBoxActive,
    setAvatarBoxActive,
    photosBoxActive,
    setPhotosBoxActive,
    foldersActive,
    setfoldersActive,
    uploadBoxToggle,
    uploadBoxActive,
    setUploadBoxActive,
    foldersToggle } = useBox();

  const {
    handleChange,
    handleSubmit,
    errors,
  } = useForm(submitForm, validate(props, true));

  const [isSubmitted, setIsSubmitted] = useState(false);
  function submitForm() {
    setIsSubmitted(true);
  }

  return (
    <div className='container'>
      <Sidebar/>

      <div className='content-left columbus'>
        {/*if no errors and form is completed, show footer table with data*/}
        {!isSubmitted ? (
          <ColumbusContent />
        ) : (
          <Footer mailBox={mailBox} setMailBox={setMailBox}>
            <StandardFooter/>
          </Footer>
        )}
      </div>

      <div className='content-right'>
        <img className='content-right--image' src={imagebg} alt="panele" />
        <Form handleSubmit={handleSubmit}>
          <Common errors={errors}/>
          <Image
            overlayToggle={overlayToggle}
            avatarBoxToggle={avatarBoxToggle}
            uploadBoxToggle={uploadBoxToggle}
            photosBoxToggle={photosBoxToggle}
            foldersToggle={foldersToggle}
            setAvatarBoxActive={setAvatarBoxActive}
            setUploadBoxActive={setUploadBoxActive}
            setPhotosBoxActive={setPhotosBoxActive}
            errors={errors}
          />
          <Button />
        </Form>
      </div>

      <Overlay overlayActive={overlayActive}>
          <AvatarBox
            handleChange={handleChange}
            avatarBoxToggle={avatarBoxToggle}
            avatarBoxActive={avatarBoxActive}
            overlayToggle={overlayToggle}
          />
          <UploadBox
            handleChange={handleChange}
            uploadBoxToggle={uploadBoxToggle}
            uploadBoxActive={uploadBoxActive}
            overlayToggle={overlayToggle}
          />
          <PhotosBox
            photosBoxToggle={photosBoxToggle}
            photosBoxActive={photosBoxActive}
            setPhotosBoxActive={setPhotosBoxActive}
            overlayToggle={overlayToggle}
            foldersActive={foldersActive}
            setfoldersActive={setfoldersActive}
            foldersToggle={foldersToggle}
          />
      </Overlay>
    </div>
  );
};

ColumbusPage.propTypes = {
  overlayActive: PropTypes.bool,
  avatarBoxActive: PropTypes.bool,
  photosBoxActive: PropTypes.bool,
  foldersActive: PropTypes.bool,
  setfoldersActive: PropTypes.bool,
  setAvatarBoxActive: PropTypes.bool,
  setPhotosBoxActive: PropTypes.bool,
  foldersToggle: PropTypes.func,
  overlayToggle: PropTypes.func,
  avatarBoxToggle: PropTypes.func,
  photosBoxToggle: PropTypes.func,
}

// send props to validate
function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
    user_image: state.user_reducer.user_image,
  }
}
export default connect(mapStateToProps)(ColumbusPage);